import { createFileRoute, Outlet } from "@tanstack/react-router";

import { AppLayout } from "../-components/app-layout";
import { AppLayoutSkeleton } from "../-components/app-layout-skeleton";

export const Route = createFileRoute("/(app)")({
	component: RouteComponent,
	pendingMinMs: 150,
	pendingComponent: AppLayoutSkeleton,
});

function RouteComponent() {
	return (
		<AppLayout>
			<Outlet />
		</AppLayout>
	);
}
